<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ $t("profile.purchase.allBuyers") }}
    </div>
    <table v-if="windowWidth >= 500">
      <thead>
        <tr>
          <td>{{ $t("profile.purchase.buyer") }}</td>
          <td>{{ $t("profile.purchase.date") }}</td>
          <td>{{ $t("profile.purchase.quantity") }}</td>
          <td>{{ $t("profile.purchase.term") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(transaction, index) in transactions" :key="index">
          <td>
            {{ transaction.usr_name }}
          </td>
          <td>
            {{ transaction.off_date }}
          </td>
          <td>
            {{ transaction.off_quantity }}
          </td>
          <td>
            {{ getTranslation(transaction.off_type) }}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="mobile-table" v-if="windowWidth < 500">
      <tbody>
        <tr v-for="(transaction, index) in transactions" :key="index">
          <td>
            <span class="bold-td-text">{{ transaction.usr_name }}</span>
          </td>
          <td class="light-grey">
            {{ transaction.off_date.substring(0, 10) }}
          </td>
          <td class="regular-td-text">{{ transaction.off_quantity }} kom.</td>
          <td class="status-color">
            {{ getTranslation(transaction.off_type) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
export default {
  name: "productBuyers",
  props: {
    modalData: {
      required: true
    }
  },
  data() {
    return {
      transactions: [],
      windowWidth: window.innerWidth
    };
  },
  mounted() {
    this.getBuyers();
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    closeModal() {
      eventBus.$emit("closeModal");
    },
    getBuyers() {
      let params = {
        pro_id: this.modalData.pro_id
      };
      api
        .getProductTransactions(params)
        .then(res => {
          this.transactions = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/tableStyles.scss";
table {
  border: none;
  thead {
    text-transform: uppercase;
  }
  td {
    border-bottom: none !important;
  }
  tbody tr:nth-child(odd) {
    background: rgba(196, 196, 196, 0.15);
  }
}
.modal-wrapper {
  width: 800px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}
.mobile-table {
  tbody tr {
    background: none !important;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
  }
  tbody tr td {
    border-bottom: none;
    vertical-align: top;
    width: 50%;
    height: 100%;
    // padding: 5px;
    padding: 5px 0;
  }
}
.bold-td-text {
  font-weight: 700;
  font-size: 17px;
}
.regular-td-text {
  font-weight: 500;
  font-size: 14px;
}
.light-grey {
  color: #9b9b9b;
  text-align: right;
  vertical-align: top;
  font-weight: 400;
  font-size: 13px;
}
.status-color {
  color: $blue-800;
  text-align: right;
  font-weight: 600;
  font-size: 13px;
}
</style>
